import { classnames } from '@aibees/shared/utils';
import { cloneElement, memo } from 'react';
import { ButtonProps } from '@mui/material';
import { combineValuesAndSearchKey } from '@aibees/elephant/feature/suggestion-search-bar/utils';
import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { SuggestionSearchBarOptionBase } from '@aibees/elephant/feature/suggestion-search-bar';
import type { ActionElementProps as Props } from './types';
import * as SX from './sx';
import * as Styled from './styles';

export const ActionElement = memo(({ className, searchButton }: Props) => {
  const { selectedItems, searchKey, onClickSearchButton } =
    useSuggestionSearchBarContext();

  const handleSearchClick: ButtonProps['onClick'] = (e) => {
    const v = combineValuesAndSearchKey<SuggestionSearchBarOptionBase>(
      selectedItems,
      searchKey,
      !!selectedItems.length
    );
    if (v && onClickSearchButton) onClickSearchButton(v);
  };

  return (
    <Styled.Wrapper
      className={classnames('ActionElement', className)}
      sx={SX.root}
    >
      {searchButton &&
        cloneElement(searchButton, {
          onClick: handleSearchClick,
          disabled: !selectedItems.length,
        })}
    </Styled.Wrapper>
  );
});

ActionElement.displayName = 'ActionElement';
